import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import moment from 'moment';

export class InProgressCall extends PhaseTask {
  isDisabled = () => false

  componentDidMount = () => {
    const {
      phase,
      task: { slug, status },
    } = this.props;

    if (phase.type !== 'Workorder' || slug !== 'workorder_in_progress_call' || status !== 'incomplete') {
      return;
    }

    const { appointments = [] } = phase;
    const notAutoAppts = ['stack_cali_bamboo', 'repair'];
    const today = moment();

    const autoAppt = appointments.some((appt) => {
      const startDate = moment(appt.start_date);
      const endDate = moment(appt.end_date);
      return today.isBetween(startDate, endDate) && !notAutoAppts.includes(appt.kind);
    });

    if (!autoAppt) return;

    const task = { status: 'complete' };
    const autocompleteNote = 'Autocompleted because appointment type is not a "Repair" or "Stack Cali Bamboo"';
    const data = { event: { data: { note: autocompleteNote } } };

    this.props.updatePhaseTask(
      phase.id,
      slug,
      { task, ...data },
    );
  }

  onClick = () => {
    const { task, phase } = this.props;
    if (phase.source === 'RF') return this.completeTask();
    return (task.status !== 'complete' ?
      this.props.navigate(urls.phaseCommunications(phase)) :
      this.toggleStatus());
  }
}

InProgressCall.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

const in_progress_call = connect(() => state => ({ user: state.user }),
  { updatePhaseTask, navigate })(InProgressCall);

export {
  in_progress_call as install_in_progress_call,
  in_progress_call as workorder_in_progress_call,
};



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/in_progress_call.jsx